export const qualityScores = [
    { score: '91-100', label: 'Publish-Ready', color: 'text-green-500', description: 'Ready for use with minimal or no edits.' },
    { score: '70-90', label: 'Flawed', color: 'text-orange-500', description: 'Understandable but contains noticeable issues. Requires human review and correction. Use with caution.' },
    { score: '1-69', label: 'Unusable', color: 'text-red-500', description: 'Difficult to understand or use reliably. Re-generate or assign for full human translation.' },
    { score: '', label: "Won't process / Error", color: 'text-[rgb(17,24,39)]', description: '' },
];

export const scoreRanges = [{ label: 'All Scores' }, { label: 'Publish-Ready' }, { label: 'Flawed' }, { label: 'Unusable' }, { label: 'Error' },];

export const scoreRules = {
    'All Scores': () => true,
    'Publish-Ready': (score) => score >= 91,
    'Flawed': (score) => score >= 70 && score <= 90,
    'Unusable': (score) => score >= 1 && score <= 69,
    'Error': (score) => score === 0,
};

export const evaluationStatuses = {
    0: { label: 'Unspecified', color: 'text-gray-500' },
    1: { label: 'Draft', color: 'text-violet-500' },
    2: { label: 'Queued', color: 'text-blue-500' },
    3: { label: 'In Progress', color: 'text-yellow-500' },
    4: { label: 'Completed', color: 'text-green-500' },
    5: { label: 'Aborted', color: 'text-red-500' },
    6: { label: 'Error', color: 'text-red-500' },
};

export const segmentStatuses = {
    0: { label: 'Unspecified', color: 'text-gray-500' },
    1: { label: 'Draft', color: 'text-gray-500' },
    2: { label: 'Queue', color: 'text-gray-500' },
    3: { label: 'In Progress', color: 'text-gray-500' },
    4: { label: "Won't process", color: 'text-gray-500' },
    5: { label: 'Processed', color: 'text-gray-500' },
    6: { label: 'Error', color: 'text-gray-500' },
};